import { useState } from 'react'

import {
  CreateFinanceInvoiceDocument,
  CreateFinanceInvoiceMutationVariables,
  GetInvoiceDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useUploadInvoice = () => {
  const [id, setId] = useState<number | undefined>(undefined)
  const { company } = useCurrentSession()

  const [uploadInvoice, { loading: creating }] = useMutation(CreateFinanceInvoiceDocument, {
    extractorFn: (data) => data.financeMutations.createWithAsyncScanFileFinanceFinancialDocument,
  })

  const { data, loading: getting } = useQuery(GetInvoiceDocument, {
    variables: { companyId: company.id, id: Number(id) },
    skip: id === undefined || !company.id,
  })

  useUnsafeEffect(() => {
    if (data) {
      setId(undefined)
    }
  }, [data])

  const invoice = useUnsafeMemo(() => data?.finance.financialDocuments[0], [data])

  return {
    uploadInvoice(variables: CreateFinanceInvoiceMutationVariables) {
      return uploadInvoice({
        variables,
      })
    },
    getInvoice(variables: { id?: number }) {
      setId(variables.id)
    },
    invoice,
    creating,
    getting,
  }
}
